import { Action } from '@ngrx/store'
import * as auditLogsTypes from './audit-logs.types'
import { AuditLog, AuditLogInfo } from './audit-logs.interface'

export class FetchAuditLogsRequest implements Action {
  readonly type = auditLogsTypes.FETCH_AUDIT_LOGS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchAuditLogsSuccess implements Action {
  readonly type = auditLogsTypes.FETCH_AUDIT_LOGS_SUCCESS
  constructor(
    public payload: AuditLog[],
    public filtered: number,
    public total: number,
  ) {}
}

export class FetchAuditLogsFailure implements Action {
  readonly type = auditLogsTypes.FETCH_AUDIT_LOGS_FAILURE
  constructor(public payload: any) {}
}

export class ExportAuditLogsRequest implements Action {
  readonly type = auditLogsTypes.EXPORT_AUDIT_LOGS_REQUEST
  constructor(public payload: any = {}) {}
}

export class ExportAuditLogsSuccess implements Action {
  readonly type = auditLogsTypes.EXPORT_AUDIT_LOGS_SUCCESS
  constructor(public blob: Blob) {}
}

export class ExportAuditLogsFailure implements Action {
  readonly type = auditLogsTypes.EXPORT_AUDIT_LOGS_FAILURE
  constructor(public payload: any) {}
}

export class FetchAuditLogInfoRequest implements Action {
  readonly type = auditLogsTypes.FETCH_AUDIT_LOG_INFO_REQUEST
  constructor(public id: number) {}
}

export class FetchAuditLogInfoSuccess implements Action {
  readonly type = auditLogsTypes.FETCH_AUDIT_LOG_INFO_SUCCESS
  constructor(public payload: AuditLogInfo[]) {}
}

export class FetchAuditLogInfoFailure implements Action {
  readonly type = auditLogsTypes.FETCH_AUDIT_LOG_INFO_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = auditLogsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = auditLogsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | SetDefaultData
  | UpdateField
  | FetchAuditLogsRequest
  | FetchAuditLogsSuccess
  | FetchAuditLogsFailure
  | FetchAuditLogInfoRequest
  | FetchAuditLogInfoSuccess
  | FetchAuditLogInfoFailure
  | ExportAuditLogsRequest
  | ExportAuditLogsSuccess
  | ExportAuditLogsFailure
